import axios from 'axios';
import { clearAuth } from '../utils/authUtil';

const API = axios.create({
          baseURL: process.env.NODE_ENV === 'production'
            ? 'https://api.zaptude.com/api'
            : 'http://localhost:5000/api',
});

API.interceptors.request.use((req) => {
          const token = localStorage.getItem("token");

          if (token) {
                      req.headers.Authorization = `Bearer ${token}`;
                    }

          return req;
}, (error) => {
          return Promise.reject(error);
});

// Requests where a 401 means "wrong credentials for THIS action", not "your session ended":
// a wrong password on the login form, or a wrong CURRENT password when changing it. Treating those as an
// expired session would sign the student out for a typo.
const CREDENTIAL_ENDPOINTS = ['/auth/login', '/auth/change-password'];

// Set on session expiry so the login screen can say why the student is back there (read + cleared by Login).
export const SESSION_NOTICE_KEY = 'zaptude_notice';

// A 401 means the token is missing/expired/invalid — clear the stale session
// and send the user back to login instead of leaving pages stuck on
// "Failed to load..." with a token that will never start working again.
API.interceptors.response.use((res) => res, (error) => {
  const url = error.config?.url || '';
  if (error.response?.status === 401 && !CREDENTIAL_ENDPOINTS.some(p => url.includes(p))) {
    // clearAuth() also clears the non-httpOnly `user` cookie and asks the
    // server to clear the httpOnly one — using it here (rather than just
    // localStorage.removeItem) means an expiry-triggered logout is a real
    // logout, not one that leaves a stale `user` cookie behind for
    // getUser() to pick back up on the next page load.
    const hadSession = !!localStorage.getItem('token');
    clearAuth();
    if (hadSession) { try { sessionStorage.setItem(SESSION_NOTICE_KEY, 'session_expired'); } catch { /* ignore */ } }
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
  }
  return Promise.reject(error);
});

export default API;
